import {cpServiceV2Get} from 'api';
import {sendSentryException} from 'utils/error-handling';
import {convertKeysToSnakeCase, camelizeKeys} from 'utils/format-strings';
import {
    DiscountItem,
    MultiDayDiscountsExampleOptions,
    MultiDayDiscountsExampleRequestParams,
    RawMultiDayDiscountsExampleResponse,
} from 'api/rates/multi-day-discounts/multi-day-discounts.types';

/**
 * Formats the options for multi-day discount examples by converting keys to snake_case.
 */
const formatMultiDayDiscountExampleOptions = (
    options: MultiDayDiscountsExampleOptions
) => {
    const formattedOptions: Partial<MultiDayDiscountsExampleOptions> =
        convertKeysToSnakeCase(options);

    return formattedOptions;
};

/**
 * Formats the response data for multi-day discounts.
 */
const formatMultiDayDiscountsResponse = (
    data: RawMultiDayDiscountsExampleResponse
) => {
    const formattedResponse: DiscountItem = camelizeKeys(data);

    return formattedResponse;
};

/**
 * Fetches a calculated example of multi-day discounts for a given facility and rule group.
 */
const getMultiDayDiscountsExample = async ({
    facilityId,
    ruleGroupId,
    options,
}: MultiDayDiscountsExampleRequestParams) => {
    try {
        const formattedOptions = formatMultiDayDiscountExampleOptions(options);

        const response =
            await cpServiceV2Get<RawMultiDayDiscountsExampleResponse>(
                `facilities/${facilityId}/rating-rule-groups/${ruleGroupId}/discounts/example`,
                formattedOptions
            );

        const formattedResponse = formatMultiDayDiscountsResponse(
            response.data.data
        );

        return formattedResponse;
    } catch (error) {
        sendSentryException(error);

        throw error;
    }
};

export default getMultiDayDiscountsExample;
